import { useState, useEffect, useCallback } from 'react';
import { CustomTour } from '../types';

interface UseCustomToursReturn {
  customTours: CustomTour[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

// Fetch custom tours without admin authentication (public endpoint)
const fetchCustomTours = async (): Promise<CustomTour[]> => {
  try {
    console.log('Fetching custom tours from /api/custom-tours...');
    const response = await fetch('/api/custom-tours');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Custom tours API response:', data);
    console.log('Custom tours items:', data.items);
    return data.items || [];
  } catch (error) {
    console.error('Error fetching custom tours:', error);
    throw error;
  }
};

export const useCustomTours = (): UseCustomToursReturn => {
  const [customTours, setCustomTours] = useState<CustomTour[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomToursData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const customToursData = await fetchCustomTours();
      setCustomTours(customToursData);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch custom tours';
      setError(errorMessage);
      console.error('Error in useCustomTours:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCustomToursData();
  }, [fetchCustomToursData]);

  const refetch = () => {
    fetchCustomToursData();
  };

  return {
    customTours,
    loading,
    error,
    refetch
  };
};
